<template>
    <div class="content-body">
        <div class="content-inside">
            <PointsContent></PointsContent>
        </div>
    </div>
</template>

<script>
import PointsContent from "./PointsContent";

export default {
    name: "userPoints",
    components: {
        PointsContent
    }
};
</script>

<style lang="scss" scoped>
h5 {
    font-size: 16px;
}
h6 {
    font-family: MainFontBold, sans-serif;
    font-size: 16px;
}
</style>
